/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendVentureFundLoanDto } from '../../models/backend-venture-fund-loan-dto';
import { BackendVentureFundLoanRequestDto } from '../../models/backend-venture-fund-loan-request-dto';

export interface VentureFundsVentureFundLoansUpdate$FormData$Params {
  id: number;
  body: BackendVentureFundLoanRequestDto;
}

export function ventureFundsVentureFundLoansUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundLoansUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundLoanDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundLoansUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundLoanDto>;
    }),
  );
}

ventureFundsVentureFundLoansUpdate$FormData.PATH = '/api/venture_funds/venture-fund-loans/{id}/';
